export default __webpack_public_path__ + "static/media/room-2Bed-double_compressed.f449299e.mp4";